import { render, staticRenderFns } from "./Especificaciones.vue?vue&type=template&id=0a7f0e7f&scoped=true&"
import script from "./Especificaciones.vue?vue&type=script&lang=js&"
export * from "./Especificaciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7f0e7f",
  null
  
)

export default component.exports